class UploadedBy {
    constructor(data) {
        this.uploader_id = data.uploader_id ? data.uploader_id : App.user.id;
        this.order_by_financial = data.order_by_financial ? data.order_by_financial : false;
        this.order_by_evolution = data.order_by_evolution ? data.order_by_evolution : false;

        this.page = data.page ? data.page : 1;
        this.take = data.take ? data.take : 10;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'uploader_id': this.uploader_id,
            'take': this.take,
            'skip': (this.page - 1) * this.take,
            'add_separator': 'song_published_at',
            'order_by_financial': this.order_by_financial,
            'order_by_evolution': this.order_by_evolution,
            'order_recent_by_publish_date': false,
            'order_recent_by_review_month': false,
            'order_by_publish_date': false,
            'favorites_first': false,
            'published': this.uploader_id != App.user.id
        };
    }
}

export default UploadedBy;
